<template>
  <div class="right-chart-3" id="right-chart-3"></div>
</template>

<script>
import { querysbblsjfsl } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const echartsDom = document.getElementById('right-chart-3')
      this.chart = this.$echarts.init(echartsDom)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await querysbblsjfsl(this.date)
      let xDatas = []
      let chartsDatas = []
      apiData.forEach(item => {
        xDatas.push(item.name)
        chartsDatas.push(item.defective || 0)
      })
      const options = {
        title: {
          text: '设备不良事件发生率',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: 40,
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          data: xDatas,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
        },
        series: [
          {
            data: chartsDatas,
            type: 'bar',
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.right-chart-3 {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
}
</style>
